import { useRoutes, Navigate } from 'react-router-dom';
import { useAWSAuth } from '../hooks/useAWSAuth';
import {
  Home,
  Payment,
  IntroGuide,
  Privacy,
  PrivacyPolicy,
  Donation,
  SignIn,
  AdminPortal,
  NewsletterDemo,
  AppDetail
} from '../pages';
import { Leaderboard } from '../pages/Leaderboard';

export default function Router() {
  const { isAuthenticated } = useAWSAuth();
  const routes = useRoutes([
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/donation/donate',
      element: <Payment />
    },
    {
      path: '/guide/intro-guide',
      element: <IntroGuide />
    },
    {
      path: '/privacy',
      element: <Privacy />
    },
    {
      path: '/privacy-policy',
      element: <PrivacyPolicy />
    },
    {
      path: '/gift',
      element: <Donation />
    },
    { path: 'admin/login', element: isAuthenticated ? <Navigate to={'/admin/portal'} replace /> : <SignIn /> },
    {
      path: 'admin/portal',
      element: isAuthenticated ? <AdminPortal /> : <Navigate to={'/admin/login'} replace />
    },
    {
      path: '/groups',
      element: <Leaderboard />
    },
    {
      path: '/newsletter-demo',
      element: <NewsletterDemo />
    },
    {
      path: '/app-detail',
      element: <AppDetail />
    },
    {
      path: '/app-detail/*',
      element: <AppDetail />
    }
  ]);
  return routes;
}
